module.exports = __webpack_public_path__ + "static/media/video_placeholder.d0f0a02d.png";